interface MfeExceptionParams {
    message: string;
    statusCode: number;
}
export class MfeException {
    public readonly message: string = '';
    public readonly statusCode: number = 400;

    constructor(params: MfeExceptionParams) {
        this.message = params.message;
        this.statusCode = params.statusCode;
    }
}
